import { useMemo } from 'react';
import { useRealtimeStatus } from './useRealtimeStatus';
import { useGenerationTimeout } from './useGenerationTimeout';
import { useAuthStore, useDocumentsStore } from '@/stores';
import { toast } from '@/components/ui/Toast';

const DOCUMENT_TIMEOUT_MS = 180_000; // 3 minutes

export function useDocumentRealtimeStatus() {
  const user = useAuthStore((s) => s.user);
  const documents = useDocumentsStore((s) => s.documents);
  const updateDocument = useDocumentsStore((s) => s.updateDocument);

  const generatingIds = useMemo(
    () =>
      documents
        .filter((d) => d.status === 'uploading' || d.status === 'processing')
        .map((d) => d.id),
    [documents]
  );

  useRealtimeStatus({
    table: 'documents',
    userId: user?.id,
    itemIds: generatingIds,
    terminalStatuses: ['indexed', 'error'],
    onStatusChange: (id, newRow) => {
      const status = newRow.status as string;
      updateDocument(id, {
        status: status as 'indexed' | 'error',
        page_count: newRow.page_count as number | undefined,
      });

      if (status === 'indexed') {
        toast.success('Document processed successfully!');
      } else if (status === 'error') {
        toast.error((newRow.error_message as string) || 'Document processing failed');
      }
    },
  });

  useGenerationTimeout({
    itemIds: generatingIds,
    timeoutMs: DOCUMENT_TIMEOUT_MS,
    onTimeout: (id) => {
      updateDocument(id, { status: 'error' });
      toast.error('Document processing timed out');
    },
  });
}
